import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let historyOrganizationObj = null
try {
  historyOrganizationObj = JSON.parse(localStorage.historyOrganization)
} catch (e) {
  historyOrganizationObj = []
}

function distinct (arr, key) {
  let newobj = {}
  let newArr = []
  for (var i = 0; i < arr.length; i++) {
    let item = arr[i]
    if (!newobj[item[key]]) {
      newobj[item[key]] = newArr.push(item)
    }
  }
  return newArr
}
export default new Vuex.Store({
  state: {
    currentCity: '济南市',
    historyOrganization: historyOrganizationObj,
    isLogin: false,
    issueDetail: {},
    isActive: window.sessionStorage.getItem('isActive') === null ? 'homeActive' : window.sessionStorage.getItem('isActive')
  },
  mutations: {
    handleIsLogin (state, payload) {
      state.isLogin = payload
    },
    handleIssueDetail (state, payload) {
      state.issueDetail = payload
    },
    handleCurrentCity (state, playload) {
      state.currentCity = playload
    },
    handleHistoryOrganization (state, playload) {
      state.historyOrganization.unshift(playload)
      const newArr = distinct(state.historyOrganization, 'orgId')
      state.historyOrganization = newArr
      if (state.historyOrganization.length > 12) {
        state.historyOrganization.pop()
      }
      localStorage.historyOrganization = JSON.stringify(newArr)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js